import { render, staticRenderFns } from "./change-salary.vue?vue&type=template&id=8fdaf08c&scoped=true&"
import script from "./change-salary.vue?vue&type=script&lang=js&"
export * from "./change-salary.vue?vue&type=script&lang=js&"
import style0 from "./change-salary.vue?vue&type=style&index=0&id=8fdaf08c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdaf08c",
  null
  
)

export default component.exports